import { z } from 'zod';

/**
 * Shared by both the create and edit forms — required-ness of fields is identical
 * in both flows (creation requires name/title/description; editing an existing
 * incentive still requires those three be non-empty in the form even though the
 * PATCH request only ever sends the fields that actually changed).
 *
 * This schema only governs "is this valid input" for vee-validate. It intentionally
 * says nothing about omit-vs-null-vs-value for the nullable fields on PATCH — that
 * tri-state is tracked by a separate `fieldState`/`IncentiveNullableFieldState`
 * side-channel (see `mappers/incentiveMappers.ts`) driven by the "Limpar" buttons,
 * and reconciled into the wire payload by the mapper, not by this schema.
 */
export const incentiveSchema = z.object({
  acceptance_criteria: z.string().trim().nullable(),
  banner_file_external_id: z.string().nullable(),
  business_rules: z.string().trim().nullable(),
  description_ptbr: z.string({ required_error: 'Descrição é obrigatória.' })
    .trim()
    .min(1, 'Descrição é obrigatória.'),
  name: z.string({ required_error: 'Nome do incentivo é obrigatório.' })
    .trim()
    .min(1, 'Nome do incentivo é obrigatório.'),
  title_ptbr: z.string({ required_error: 'Título é obrigatório.' })
    .trim()
    .min(1, 'Título é obrigatório.'),
  trigger_description: z.string().trim().nullable(),
});

export type IncentiveFormValues = z.infer<typeof incentiveSchema>;

export function createEmptyIncentiveFormValues(): IncentiveFormValues {
  return {
    acceptance_criteria: null,
    banner_file_external_id: null,
    business_rules: null,
    description_ptbr: '',
    name: '',
    title_ptbr: '',
    trigger_description: null,
  };
}
